export default __webpack_public_path__ + "static/media/03d.61981d54.png";